"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var Storage = __importStar(require("../../Actions/Storage"));
var RevSingleImageUploader = function RevSingleImageUploader(props) {
  var readOnly = props.schema.readOnly;
  var _a = react_1.default.useState({
      uid: '',
      url: '',
      fields: {},
      filename: '',
      expected: ''
    }),
    image = _a[0],
    setImage = _a[1];
  var beforeUpload = function beforeUpload(file) {
    return __awaiter(void 0, void 0, void 0, function () {
      var unique_key, resp_1, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            unique_key = typeof props.schema.unique_key === 'boolean' ? props.schema.unique_key : true;
            return [4 /*yield*/, Storage.getUploadUrlFromFile(file, {
              unique_key: unique_key
            })];
          case 1:
            resp_1 = _a.sent();
            setImage(function (prev) {
              return __assign(__assign({}, prev), resp_1);
            });
            return [3 /*break*/, 3];
          case 2:
            e_1 = _a.sent();
            console.log(e_1);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };

  var onFileChange = function onFileChange(pramas) {
    var file = pramas.file;
    if (file.status === 'done') {
      setImage(__assign(__assign({}, image), {
        uid: file.uid,
        filename: file.name
      }));
      props.onChange(image.expected);
    }
  };
  return react_1.default.createElement(antd_1.Upload, {
    key: props.value,
    maxCount: 1,
    onChange: onFileChange,
    beforeUpload: beforeUpload,
    disabled: !!readOnly,
    defaultFileList: props.value ? [{
      uid: '1',
      name: '下載',
      status: 'done',
      url: props.value
    }] : [],
    accept: props.schema.accept || 'image/*',
    listType: props.schema.previewType || 'picture-card',
    onPreview: function onPreview() {
      if (props.value) {
        window.open(props.value);
      } else {
        window.open("" + image.expected);
      }
    },
    onRemove: function onRemove() {
      props.onChange('');
    },
    action: image.url,
    data: image.fields
  }, react_1.default.createElement(antd_1.Button, {
    style: {
      margin: '10px 0'
    },
    icon: react_1.default.createElement(icons_1.UploadOutlined, null),
    disabled: !!readOnly
  }, "\u4E0A\u50B3"));
};
exports.default = RevSingleImageUploader;